<template>
  <div class="detial-content-item">
    <div class="detial-content-item-name">{{ title }}</div>
    <div class="detial-content-item-value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: 'PayItem',
  props: {
    title: String,
    value: String
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
